import React from 'react';

const RSVP: React.FC = () => {
  const formUrl = 'https://forms.gle/EeARnZBN2UrKMyTK7';
  return (
    <div className="py-10">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h1 className="text-4xl md:text-5xl font-wedding text-gray-900 mb-3">
            RSVP
          </h1>
          <p className="text-xl text-gray-600">
            Please let us know if you can join us!
          </p>
        </div>

        <div className="wedding-card">
          {formUrl ? (
            <div>
              <div className="rounded-lg overflow-hidden border border-gray-200">
                <iframe
                  title="RSVP Google Form"
                  src={formUrl}
                  className="w-full h-[1100px] md:h-[1200px]"
                  loading="lazy"
                />
              </div>
              <p className="text-sm text-gray-500 mt-3 text-center">
                If the form doesn't load,{' '}
                <a
                  href={formUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary-600 hover:text-primary-700 underline"
                >
                  open it in a new tab
                </a>
                .
              </p>
            </div>
          ) : (
            <div className="text-center">
              <p className="text-gray-600 mb-4">
                Our RSVP form will appear here.
              </p>
              <p className="text-sm text-gray-500">
                Admin note: set <code>REACT_APP_GOOGLE_FORM_URL</code> in <code>frontend/.env.local</code> to embed the Google Form.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RSVP; 